export default "__VITE_ASSET__58547e6f__"